export default {
  unknown_error:
    "Unknown server error occurred. Please contact us via feedback form.",
  captcha_error: "Please confirm that you're a human!",
  continue: "Continue",
  submit: "Submit",
  learn_more: "Learn more",
  clear: "Clear",
  cancel: "Cancel",
  search: "Search",
  search_by_number: "Search by codes",
  product_code: "Code",
  product_name: "Name",
  no_vat: "w/o VAT",
  price: "Price",
  price_rub: "Price, RUB",
  sum_rub: "Total, RUB",
  total_vat_rub: "Total with VAT, RUB",
  total_rub: "Total, RUB",
  vat_rub: "VAT (20%), RUB",
  quantity: "Quantity",
  quantity_short: "Qnt",
  profile: "Profile",
  login: "Login",
  first_name: "First name",
  last_name: "Last name",
  company_name: "Company name",
  company_ownership: "Type of ownership",
  phone: "Phone number",
  country_phone: "Country and phone number",
  inn: "Tax number",
  kpp: "Additional tax number",
  set_password: "Password",
  confirm_password: "Confirm password",
  news: "News",
  all_news: "All news",
  orders: "Orders",
  favourites: "Favourite products",
  add_favourites: "Add to favourites",
  remove_favourites: "Remove from favourites",
  in_favourites: "Product already in favourites",
  to_homepage: "To homepage",
  cart: "Cart",
  go_to_cart: "Go to cart",
  express: "Express",
  prev_btn: "Previous",
  next_btn: "Next",
  price_requests: "My requests",
  search_history: "Search history",
  print: "Print",
  save: "Save",
  specialization: "Specialization",
  all_vehicles: "All types of vehicles",
  where_to_buy: "Where to buy?",
  list_of_distributors: "List of distributors",
  download_order_file: "Download order file",
  select_distributor: "Select distributor",
  maker_engine: "Manufacturer",
  model_engine: "Engine model",
  show: "Show",
  applicability: "Applicability",
  mark: "Brand",
  model: "Model",
  year_manufacture: "Year of manufacture",
  engine: "Engine",
  makers: "Manufacturers",
  apply: "Apply",
  apply_filters: "Apply filters",
  all_products: "View all",

  quantity_pcs: "Quantity, pcs.",
  add_comment: "Add comment",
  // order_checkout_manager_contact_text: 'Checkout your order and our manager will contact you shortly. Total price is specified without delivery',
  print_document: "Print document",
  delete_cart: "Clear cart",
  empty_cart: "Your cart is empty.",
  delete_cart_confirm_1: "Are you sure you want to clear cart?",
  delete_cart_confirm_2: "Confirm action!",
  checkout_confirm_1: "Confirm order checkout!",
  checkout_confirm_2: "Order can not be changed after checkout!",
  checkout_success_header: "Your order is submitted!",
  checkout_success_text_1: "Our manager will contact you shortly.",
  checkout_success_text_1_retailer:
    "Distributor' manager will contact you shortly.",
  checkout_success_text_2:
    'We sent order document to an Email you specified during the registration. If you did not receive it please check "Spam" folder.',
  checkout_distributors_list_1:
    "Your order will be sent to these distributors:",
  checkout_distributors_list_2: "You can change distributors on",
  checkout_distributors_list_3: "Profile page",
  added_pcs: "added",
  deleted_pcs: "removed",
  pcs: "pcs.",
  products_moved_warning:
    "Warning! Due to products stocks movement, these positions have been changed:",
  print_cart: "Print cart",

  page_title: "Orders - Personal account",
  search_by_order_number_product: "Product name, article number, order number",
  dates: "Date",
  period: "Period",
  availability: "Availability",
  stock: "Stock",
  stock_pcs: "Stock, pcs.",
  store_pcs: "In Stock, pcs.",
  stock_type_available: "Available",
  stock_type_transit: "In transit",
  stock_type_preorder: "Preorder",
  stock_type_available_mobile: "Available",
  stock_type_transit_mobile: "Transit",
  stock_type_preorder_mobile: "Preorder",
  period_all: "All time",
  period_today: "Today",
  period_yesterday: "Yesterday",
  period_week: "Week",
  // period_week: 'This week',
  period_lastweek: "Last week",
  period_month: "Month",
  // period_month: 'This month',
  period_lastmonth: "Last month",
  period_year: "Year",
  // period_year: 'This year',
  period_lastyear: "Last year",

  open_orders: "Open orders",
  shipment: "Shipments",
  orders_history: "Orders history",
  orders_history_phone: "History",

  orders_open: "Oders opened",
  available: "Available",
  order_number: "Order #",
  date: "Date",
  date_order: "Order date",
  status: "Status",
  statuses: "Statuses",
  position_qnt: "Item count",
  order_save: "Order save",

  oo_download_excel: "Download excel file",
  oo_manager_shipment_notify: "Shipment available orders",
  total_without_vat: "Total sum without VAT:",
  total_without_vat_phone: "Total:",

  manager_shipment_notify: "Manager notification",
  manager_shipment_notified: "Manager will connect you soon",

  delivery_deadline: "delivery deadline",
  delivery_deadline_from: "delivery deadline from",
  delivery_deadline_to: "delivery deadline to",
  day_1: "day",
  day_2: "days",
  day_3: "days",

  shipments: "Shipments",
  delivery_date: "Shipping date",
  number: "Number",
  total_shipment: "Total shipment sum wit VAT",
  debt: "Debt RUB",
  date_payment: "Payment date",
  documents: "Documents",

  brand: 'Brand',
  transit_delivery: 'delivery date will be available in "Open orders"',

  product_added_to_cart: "Product is added to cart.",
  product_added_to_fav: "Product is added to favourites.",
  product_removed_from_fav: "Product is removed from favourites.",
  add_any_quantity: "enter any quantity to cart",
  amount_updated_date: "Amount actual on date: ",
  requested_quantity: "Quantity, pcs.",
  pdf_download_remains: "Remains & prices",
  pdf_download_crosses: "Crosses",
  expected_shipment_date: "Expected shipment date",
  pcs_transit: "pcs. in transit",

  city: "City",
  main_distributor: "Main distributor",
  main_distributor_address: "Main distributor address",
  add_distributors: "Add distributors",

  to_apply_discount:
    "To apply discount {discount}% your should increaseн quantity to {min_qnt}.",

  // articul: "Product",
  discount_min_qnt: "Min. quantity",
  discount_value: "Discount %",
  on_request: 'On request',
  payment_standard: 'Standard payment terms',
  discount_rub: 'Discount sum, rub',
  discounted_rub: 'Total with discount, rub',
  
  rub: 'rub',
}
